export default __webpack_public_path__ + "static/process-payments-f06a967f389c04303cfe24651e88164f.png";